import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function PricingSection() {
  return <section id="pricing" className="py-24 lg:py-32 bg-navy-800 border-t border-steel-800 relative overflow-hidden" data-id="element-113">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-114"></div>

      <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center relative z-10" data-id="element-115">
        <FadeIn data-id="element-116">
          <h2 className="text-4xl sm:text-5xl font-bold mb-8 font-serif" data-id="element-117">
            ¿CUÁNTO VALE VOLVER A TENER PAZ?
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-118">
          <p className="text-xl text-offwhite/90 mb-12 leading-relaxed" data-id="element-119">
            Vivir atrapado en tu cabeza tiene un coste demasiado alto. Analizar
            el origen de tu ansiedad podría costarte{' '}
            <span className="line-through text-steel-500" data-id="element-120">$80 USD</span> por una
            sola sesión de terapia.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-121">
          <div id="pricing-box" className="p-8 sm:p-12 bg-navy-900 border border-amber-500/20 rounded-sm shadow-2xl" data-id="element-122">
            <p className="text-lg text-offwhite/80 mb-8" data-id="element-123">
              Pero si lo que necesitas es el interruptor para apagar el ruido
              ahora mismo, puedes tenerlo por el precio de un café.
            </p>

            <div className="mb-10" data-id="element-124">
              <span className="text-sm text-amber-500 font-bold tracking-widest uppercase block mb-2" data-id="element-125">
                Pago Único
              </span>
              <span className="text-6xl font-bold text-white" data-id="element-126">$6.36</span>
              <span className="text-xl text-offwhite/60 ml-2" data-id="element-127">USD</span>
            </div>

            <motion.a href="https://shopcoremethod.com/cart/46096626090181:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(201, 168, 76, 0)', '0 0 0 15px rgba(201, 168, 76, 0.1)', '0 0 0 0 rgba(201, 168, 76, 0)']
          }} transition={{
            boxShadow: {
              duration: 2,
              repeat: Infinity
            }
          }} className="w-full bg-amber-500 hover:bg-amber-400 text-navy-900 font-bold text-lg sm:text-xl px-8 py-5 rounded-sm transition-colors duration-300 flex flex-col items-center justify-center gap-1 no-underline" data-id="element-128">
              <span data-id="element-129">SÍ, QUIERO RECUPERAR MI PAZ MENTAL</span>
              <span className="text-sm font-medium opacity-80" data-id="element-130">
                — $6.36 USD —
              </span>
            </motion.a>

            <p className="text-sm text-offwhite/50 mt-6" data-id="element-131">
              Acceso inmediato al protocolo completo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}